import { WizardStep } from './wizardStep';
import { INotificationService } from '../notificationservice';


export class WizardController implements ng.IController {
    currentStep: WizardStep;
    wizardSteps: WizardStep[];
    isLastStepConfirmationPage: boolean;
    onClickCheck: boolean;
    onClickMessage: string;

    static $inject = ['$scope', 'NotificationService'];

    constructor(private $scope: ng.IScope,
        private _notificationService: INotificationService) {
    }

    $onInit() {
        this.currentStep = this.wizardSteps[0];
    }

    nextStep(): void {
        if (this.onClickCheck !== undefined) {
            if (this.onClickCheck) {
                if (this.currentStep.nextAction) {
                    this.currentStep.nextAction().then(goNext => {
                        if (goNext && !this.isLastStep()) {
                            this.goToNextStep();
                        }
                    });
                } else {
                    this.goToNextStep();
                }
            }
            else {
                this._notificationService.showAlertWithOk(this.onClickMessage);
            }
        }
        else {
            if (this.currentStep.nextAction) {
                this.currentStep.nextAction().then(goNext => {
                    if (goNext && !this.isLastStep()) {
                        this.goToNextStep();
                    }
                });
            } else {
                this.goToNextStep();
            }
        } 
    }



    goToNextStep(): void {
        const currentStepIndex = this.wizardSteps.indexOf(this.currentStep);
        if (currentStepIndex !== -1) {
            this.currentStep = this.wizardSteps[currentStepIndex + 1];
        }
        this.$scope.$evalAsync();
    }

    isFirstStep(): boolean {
        return this.currentStep === this.wizardSteps[0];
    }

    previousStep(): void {
        if (this.currentStep.backAction) {
            this.currentStep.backAction().then(goNext => {
                if (goNext) {
                    this.goToPreviousStep();
                }
            });
        } else {
            this.goToPreviousStep();
        }
    }

    goToPreviousStep(): void {
        const currentStepIndex = this.wizardSteps.indexOf(this.currentStep);
        if (currentStepIndex !== -1) {
            this.currentStep = this.wizardSteps[currentStepIndex - 1];
        }
    }

    isLastStep(): boolean {
        return this.currentStep === this.wizardSteps[this.wizardSteps.length - 1];
    }

    createArray(): Array<any> {
        if (this.isLastStepConfirmationPage !== undefined && this.isLastStepConfirmationPage) {
            return new Array(this.wizardSteps.length - 1);
        }
        return new Array(this.wizardSteps.length);
    }

    getCurrentStepIndex(): number {
        return this.wizardSteps.indexOf(this.currentStep);
    }
}

angular
    .module('deliveryCreate.app')
    .controller('WizardController', WizardController);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/wizard/wizardController.ts
 **/